import React from 'react'
import { StyleSheet, View } from 'react-native'

import Loading from '@/components/Mini/Loading'

import * as d10 from '@/router/(root)/daily10/d10Module'
import { D10Header as Header } from '@/components/Mini/Header'
import { D10Background as Background } from '@/components/Mini/Background'
import { D10LeaderboardCard as LeaderboardCard } from '@/components/Mini/LeaderboardCard'

export function Daily10LeaderboardScreen() {
  const { status } = d10.useD10QueryStatus()
  const { leaderboard } = d10.useD10QueryLeaderboard()
  const handleClose = d10.useHandleClose()
  const theme = d10.useStore((s) => s.theme)

  const loading = leaderboard && status ? false : true
  //const loading = true;

  return (
    <Background>
      <Header title="Today's Leaderboard" handler={handleClose} />

      {loading && <Loading color={theme.accent} />}

      {!loading && (
        <View style={styles.content}>
          <LeaderboardCard />
        </View>
      )}
    </Background>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'transparent',
    paddingBottom: 24
  },
  content: {
    flex: 1,
    paddingHorizontal: 16
  }
})
